import SidebarCollapse from "@builder/components/app/SidebarCollapse";
import EditableInfo from "@builder/components/editable/EditableInfo";
import { EditableProps } from "@builder/components/editable/editableProps";
import EditIcon from "../../EditIcon";
import DynamicDataSelectorInput from "@builder/components/general/DynamicSelectorInput";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { SimpleCartNode } from "@common/build/types";
import { getSelectedNode } from "@builder/store/slices/BuilderSlice/builderSelectors";
import { updateNodeProperty } from "@builder/store/slices/BuilderSlice/builderSlice";
import Toggle from "@builder/components/general/Toggle";

const EditCartActiveCustomer = ({ parent }: EditableProps) => {
    const dispatch = useAppDispatch();
    const node = useAppSelector(getSelectedNode) as SimpleCartNode;
    const showActiveCustomer = node.expandedNode.showActiveCustomer;
    const showActiveCustomerCallback = (checked: boolean) => {
        dispatch(updateNodeProperty({ propertyPath: ["expandedNode", "showActiveCustomer"], value: checked }));
    };

    return (
        <SidebarCollapse title="Active customer chip" parent={parent}>
            <EditableInfo
                header="simpleCartCustomerHeader"
                body="simpleCartCustomerBody1"
                bulletPoints={{
                    points: ["simpleCartCustomerPoint1", "simpleCartCustomerPoint2"],
                    title: "simpleCartCustomerPointTitle"
                }}
            />
            <Toggle label="Show active customer" checked={showActiveCustomer !== false} callback={showActiveCustomerCallback} />
            {showActiveCustomer !== false && (
                <>
                    <DynamicDataSelectorInput title={"Select customer data"} />
                    <EditIcon customLabel="Select active customer icon" noWrapper path={["expandedNode", "customerIcon"]} />
                    <EditIcon customLabel="Select remove customer icon" noWrapper path={["expandedNode", "customerXIcon"]} />
                </>
            )}
        </SidebarCollapse>
    );
};

export default EditCartActiveCustomer;
